import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Checkbox, Dropdown,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import './style.scss';

function CustomDocumentInputs({
  customFields, updateCustomFields,
}) {
  return (
    <Dropdown
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      overlay={(
        <div className="custom-doc-inputs__content">
          <div className="custom-doc-inputs__content-section">
            <H3Text text="Visible Inputs" className="custom-doc-inputs__content-title" />
            {
              customFields?.filter((item) => item?.isActive && item?.visible)?.map((item) => (
                <div key={item?.cfId}>
                  <Checkbox
                    disabled={item?.isRequired}
                    checked={item?.visible}
                    onChange={() => {
                      const customFieldsCopy = JSON.parse(JSON.stringify(customFields));
                      for (let i = 0; i < customFieldsCopy?.length; i++) {
                        if (item?.cfId === customFieldsCopy[i]?.cfId) {
                          customFieldsCopy[i].visible = !item.visible;
                        }
                      }
                      updateCustomFields(customFieldsCopy);
                    }}
                  >
                    {item?.fieldName}
                  </Checkbox>
                </div>
              ))
            }
          </div>
          {customFields?.filter((item) => item?.isActive && !item?.visible)?.length ? (
            <div className="custom-doc-inputs__content-section">
              <H3Text text="Other Inputs" className="custom-doc-inputs__content-title" />
              {
                customFields.filter((item) => item?.isActive && !item?.visible)?.map((item) => (
                  <div key={item?.cfId}>
                    <Checkbox
                      disabled={item?.isRequired}
                      checked={item?.visible}
                      onChange={() => {
                        const customFieldsCopy = JSON.parse(JSON.stringify(customFields));
                        for (let i = 0; i < customFieldsCopy?.length; i++) {
                          if (item?.cfId === customFieldsCopy[i]?.cfId) {
                            customFieldsCopy[i].visible = !item.visible;
                          }
                        }
                        updateCustomFields(customFieldsCopy);
                      }}
                    >
                      {item?.fieldName}
                    </Checkbox>
                  </div>
                ))
              }
            </div>
          ) : ''}
        </div>
      )}
      trigger={['click']}
      placement="bottomLeft"
    >
      <div className="custom-doc-inputs__wrapper">
        <FontAwesomeIcon icon={faGear} />
        &nbsp;
        More Inputs
      </div>
    </Dropdown>
  );
}

const mapStateToProps = ({

}) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

CustomDocumentInputs.propTypes = {

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomDocumentInputs));
